import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-custom-search-select-dropdown',
  templateUrl: './custom-search-select-dropdown.component.html',
  styleUrls: ['./custom-search-select-dropdown.component.less'],
})
export class CustomSearchSelectDropdownComponent implements OnInit {
  @Input() Options: { value: string, key: any }[] = [];
  @Input() placeholder: string = 'Select';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter();
  @Input() dropdownWidth: any = 273;
  @Input() showSearch: boolean = false;
  @Input() value: any = '';

  isOpen: boolean = false;
  selectedValue: string = '';
  searchTerm: string = '';
  filteredOptions: any = [];
  fieldId: string = '';
  isFocusInside: boolean = false;

  @ViewChild('input') fieldRef: ElementRef;

  constructor(private elementRef: ElementRef) {
    this.fieldId = Math.random().toString(36).substring(2, 9);
  }

  ngOnInit(): void {
    this.filteredOptions = this.Options;
  }

  get displayValue(): string {
    if (this.Options && this.value !== undefined) {
      const match = this.Options.find(function (option) {
        return option.key == this.value;
      }.bind(this));
      return match ? match.value.toString() : '';
    }
    return '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Options'] && !changes['Options'].firstChange) {
      this.filteredOptions = this.Options;
    }
  }

  openDropdown(): void {
    if (!this.showSearch) {
      this.isOpen = !this.isOpen;
    }
    this.filteredOptions = this.Options;
  }

  searchChange(searchKey: any): void {
    this.searchTerm = searchKey;
    this.selectedValue = '';
    if (this.showSearch && searchKey === '') {
      this.isOpen = false;
    } else {
      this.isOpen = true;
    }
    this.filterOptions();
  }

  filterOptions(): void {
    this.filteredOptions = this.Options.filter(function (option) {
      return option && option.value && option.value.toLowerCase().includes(this.searchTerm.toLowerCase());
    }.bind(this));
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: any): void {
    this.selectedValue = option.value;
    this.valueChange.emit(option.key);

    if (this.fieldRef && this.fieldRef.nativeElement) {
      this.fieldRef.nativeElement.value = this.displayValue;
    }

    this.isOpen = false;
  }

  onBlur(): void {
    if (this.selectedValue === '') {
      this.clearSelection();
    }
  }

  clearSelection(): void {
    this.valueChange.emit(undefined);
    if (this.fieldRef && this.fieldRef.nativeElement) {
      this.fieldRef.nativeElement.value = '';
    }
  }

  @HostListener('document:click', ['$event'])
  clickOutsideDropdown(event: Event): void {
    const target = event.target as HTMLElement;
    if (!this.isOpen || this.elementRef.nativeElement.contains(target)) {
      return;
    }
    this.isOpen = false;
  }

  handleTab(isLast: boolean): void {
    if (isLast) {
      this.isOpen = false;
    }
  }

  handleFocusIn(): void {
    this.isFocusInside = true;
  }

  handleFocusOut(): void {
    setTimeout(() => {
      if (!this.isFocusInside) {
        this.isOpen = false;
      }
    });
  }

  handleTabInput(event: any, fieldId: string): void {
    const activeElement = document.activeElement as HTMLElement;
    if (event.key === 'Tab' && activeElement && activeElement.id === fieldId) {
      this.isFocusInside = false;
    }
  }
}
